import React from 'react';
import PropTypes from 'prop-types';

import { Breadcrumbs, Tooltip, Typography, Box } from '@material-ui/core';

import { LFTooltip } from './../Tooltips';

import { Link } from 'react-router-dom';

const BreadcrumbsList = ({ breadcrumbs }) => {
  return (
    <Breadcrumbs aria-label="breadcrumb">
      {breadcrumbs &&
        breadcrumbs.map((item, index) => {
          let path = 'path' in item ? (item.path ? item.path : null) : null;
          let title = 'title' in item ? (item.title ? item.title : null) : null;
          let bcElement = null;
          if (index !== breadcrumbs.length - 1) {
            bcElement = (
              <LFTooltip title={`ไปยัง ${title}`}>
                <Typography component="div" key={index}>
                  <Box fontSize="fontSize">
                    <Link
                      to={path}
                      style={{ textDecoration: 'none', color: '#0000A0' }}
                    >
                      {title}
                    </Link>
                  </Box>
                </Typography>
              </LFTooltip>
            );
          } else if (title) {
            bcElement = (
              <Typography component="div" color="textPrimary" key={index}>
                <Box fontSize="fontSize">{title} </Box>
              </Typography>
            );
          }
          return bcElement;
        })}
    </Breadcrumbs>
  );
};

/**
 * DatTable's propTypes
 */
BreadcrumbsList.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default React.memo(BreadcrumbsList);
